<template>
  <div :class="['dropdown-menu-wrapper', `size-${size}`]">
    <button
      class="setup-buttons__info-btn"
      :id="buttonId"
      aria-haspopup="true"
      :aria-expanded="ariaExpanded"
      :aria-controls="menuId"
      aria-label="Link options"
      @click="expand"
    >
    </button>
    <DropdownMenu
      class="dropdown-menu_white"
      :id="menuId"
      :aria-labelledby="buttonId"
      :expanded="expanded"
      :menu="getMenu"
    />
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { COMMUNITY_URL } from '@/constants/global';
import dropdownMenu from '@/mixins/dropdown-menu';

const SIZES = {
  DEFAULT: 'default',
  SMALL: 'small',
};

export default {
  name: 'SetupSupportAction',
  mixins: [dropdownMenu],
  props: {
    size: {
      type: String,
      default: SIZES.DEFAULT,
      validator(value) {
        return Object.values(SIZES).includes(value);
      },
    },
  },
  computed: {
    ...mapGetters({
      userLoggedIn: 'user/userLoggedIn',
      user: 'user/user',
      isUserSupporter: 'user/isUserSupporter',
    }),
    getMenu() {
      const joinOurDiscord = [{
        name: 'Connect with the community',
        icon: require('@/assets/icons/optimized/growth_team_thin.svg'),
        action: () => {
          window.open(COMMUNITY_URL, '_blank');
        },
      }, { separator: true }];
      const menuItems = [
        {
          name: 'Help Centre',
          icon: require('@/assets/icons/optimized/dropdown-menu/circle_gray.svg'),
          action: () => {
            window.open('https://helpcentre.tryb.cc/portal/en/kb/tryb', '_self');
          },
        },
        {
          separator: true,
        },
        {
          name: 'Chat with us',
          icon: require('@/assets/icons/optimized/dropdown-menu/chat_gray.svg'),
          action: () => {
            // https://www.zoho.com/salesiq/help/developer-section/js-api-chat-float-chat-window-visibility.html
            window.$zoho.salesiq.floatwindow.visible('show');
          },
        },
        {
          separator: true,
        },
        {
          name: 'Email us',
          icon: require('@/assets/icons/optimized/dropdown-menu/message_gray.svg'),
          action: () => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.$router.push({ name: 'ContactUs' });
          },
        },
      ];
      return this.userLoggedIn && !this.isUserSupporter ? [...joinOurDiscord, ...menuItems] : menuItems;
    },
  },
};
</script>

<style lang="scss" scoped>

.setup-buttons__info-btn {
  width: inherit;
  height: inherit;
  border-radius: 50%;
  background-image: url("~@/assets/icons/optimized/gradient/question_gradient.svg");
  background-size: contain;
}

.size {
  &-default {
    width: 40px;
    height: 40px;
  }

  &-small {
    width: 34px;
    height: 34px;
  }
}
</style>
